export const getInitials = (name: string) => {
  const words = name.split(" ");
  // Ensure there are at least two words in the name
  if (words.length >= 2) {
    const firstNameInitial = words[0].charAt(0);
    const lastNameSecondInitial = words[words.length - 1].charAt(0);
    return `${firstNameInitial.toUpperCase()}${lastNameSecondInitial.toUpperCase()}`;
  } else {
    // Handle cases where there are not enough words
    const initials = words
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
    return initials;
  }
};

export const isOneChecked = (search: string, touched, values) => {
  const isTouched = Object.keys(touched).some((key) => key.startsWith(search));
  const anySelected = Object.keys(values).some(
    (key) => key.startsWith(search) && values[key],
  );
  return isTouched && !anySelected;
};

export const hasTrueValueWithPrefix = <T extends object>(
  obj: T,
  prefix: string,
): boolean =>
  obj &&
  typeof obj === "object" &&
  !!Object.entries(obj).find(
    ([key, value]) =>
      (typeof value === "object" && hasTrueValueWithPrefix(value, prefix)) ||
      (value === true && String(key).startsWith(prefix)),
  );
